export const POST_ORDER_TYPE_PUBLISH_DATE = '1';
export const POST_ORDER_TYPE_VIEW_COUNT = '2';
export const POST_ORDER_TYPE_LIKE_COUNT = '3';

export const DEFAULT_POST_ORDER_TYPE = POST_ORDER_TYPE_PUBLISH_DATE;
